import { applySnapshot, cast, getParent, getSnapshot, types } from 'mobx-state-tree';
import { ContactInformation } from './contactInformation';
import { FeeStructure } from './feeStructure';
import { FeeStructureV2 } from './feeStructureV2';
import { PropertyInformation, PropertyInformationInitialData } from './propertyInformation';
import { UnitSetup } from './unitSetup';
import { UtilitiesSetupV2 } from './utilitiesSetupV2';
import { toJS } from 'mobx';
import { generateAddressString } from 'src/utils/address';
import { BUILDING_CONTACT_TYPES } from 'src/constants/property';
import { ResidentsSetup } from './residentsSetup';
const areEqual = (array1, array2) => {
  if (array1.length === array2.length) {
    return array1.every(element => {
      if (array2.filter(filteredElement => filteredElement.id === element.id).length) {
        return true;
      }
      return false;
    });
  }
  return false;
};
const AddNewProperty = types.model('AddNewProperty', {
  portfolioId: types.optional(types.string, ''),
  portfolioIds: types.optional(types.array(types.string), []),
  accountAccess: types.optional(types.array(types.string), []),
  propertyId: types.optional(types.string, ''),
  propertyInformation: types.optional(PropertyInformation, PropertyInformationInitialData),
  residentsSetup: types.optional(ResidentsSetup, {
    residents: []
  }),
  contactInformation: types.optional(ContactInformation, {}),
  feeStructure: types.optional(FeeStructure, {}),
  feeStructureV2: types.optional(FeeStructureV2, {}),
  unitSetup: types.optional(UnitSetup, {}),
  utilitiesSetupV2: types.optional(UtilitiesSetupV2, {}),
  completedStep: 0,
  activeStep: types.optional(types.string, ''),
  vacantUnitUsageLimitValue: types.map(types.number),
  vacantUnitUsageValue: types.map(types.string)
}).actions(store => {
  const initialState = getSnapshot(store);
  return {
    setVacantUnitUsageLimit(id, value) {
      try {
        store.vacantUnitUsageLimitValue.set(id, value);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    resetStoreToInitValues() {
      try {
        localStorage.removeItem('livable_property_id');
        applySnapshot(store, initialState);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeCompletedStep(step) {
      try {
        if (store.completedStep < step) store.completedStep = step;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeActiveStep(step) {
      try {
        store.activeStep = step;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPortfolioId(id) {
      try {
        store.portfolioId = id;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPortfolioIds(ids) {
      try {
        store.portfolioIds = ids;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setAccountAccess(accountIds) {
      try {
        store.accountAccess = accountIds;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPropertyId(id) {
      try {
        store.propertyId = id;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    cleanUpPropertyInformation() {
      try {
        store.propertyInformation = {
          propertyAddress: '',
          ownership: '',
          buildingSquare: ''
        };
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPropertyInformation(data) {
      try {
        store.propertyInformation = {
          propertyAddress: data.propertyAddress || toJS(store.propertyInformation.propertyAddress),
          ownership: data.ownership || toJS(store.propertyInformation.ownership),
          buildingSquare: data.buildingSquare !== 'null' && data.buildingSquare !== null && data.buildingSquare !== 'undefined' && data.buildingSquare !== undefined ? "".concat(data.buildingSquare) : ''
        };
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setTeammembers(data) {
      try {
        store.contactInformation.teammembers = cast(data);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    addNewTeammember(data) {
      try {
        store.contactInformation.teammembers.push(data);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setContactInfoAfterLoad(data) {
      try {
        data.map(item => {
          store.contactInformation.teammembers.map(teammemberItem => {
            if (teammemberItem.id === item.teamMemberId && teammemberItem.accountId !== getParent(store).account.userProfile.id) {
              if (item.contactType === BUILDING_CONTACT_TYPES.building && store.contactInformation.selectBuildingContacts.filter(contactUnit => contactUnit.id === item.teamMemberId).length === 0) {
                var _teammemberItem$email;
                store.contactInformation.selectBuildingContacts.push({
                  id: teammemberItem.id,
                  firstName: teammemberItem.firstName,
                  lastName: teammemberItem.lastName,
                  userRole: teammemberItem.userRole,
                  email: (_teammemberItem$email = teammemberItem.email) !== null && _teammemberItem$email !== void 0 ? _teammemberItem$email : teammemberItem.newEmail,
                  emailConfirmed: teammemberItem.emailConfirmed
                });
              }
              if (item.contactType === BUILDING_CONTACT_TYPES.utility && store.contactInformation.selectUtilitiesContacts.filter(contactUnit => contactUnit.id === item.teamMemberId).length === 0) {
                var _teammemberItem$email2;
                store.contactInformation.selectUtilitiesContacts.push({
                  id: teammemberItem.id,
                  firstName: teammemberItem.firstName,
                  lastName: teammemberItem.lastName,
                  userRole: teammemberItem.userRole,
                  email: (_teammemberItem$email2 = teammemberItem.email) !== null && _teammemberItem$email2 !== void 0 ? _teammemberItem$email2 : teammemberItem.newEmail,
                  emailConfirmed: teammemberItem.emailConfirmed
                });
              }
            }
          });
        });
        if (areEqual(store.contactInformation.selectBuildingContacts, store.contactInformation.selectUtilitiesContacts)) {
          store.contactInformation.selectUtilitiesContacts = cast([]);
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPropertyInfo(data) {
      try {
        var _data$buildings$, _data$buildings$2, _data$buildings$3, _data$buildings$4, _data$accountAccess, _data$accountAccess2;
        store.propertyInformation = {
          propertyAddress: generateAddressString(data.address),
          ownership: data.ownership,
          buildingSquare: (data === null || data === void 0 || (_data$buildings$ = data.buildings[0]) === null || _data$buildings$ === void 0 ? void 0 : _data$buildings$.buildingSquare) !== null && (data === null || data === void 0 || (_data$buildings$2 = data.buildings[0]) === null || _data$buildings$2 === void 0 ? void 0 : _data$buildings$2.buildingSquare) !== 'null' && (data === null || data === void 0 || (_data$buildings$3 = data.buildings[0]) === null || _data$buildings$3 === void 0 ? void 0 : _data$buildings$3.buildingSquare) !== undefined && (data === null || data === void 0 || (_data$buildings$4 = data.buildings[0]) === null || _data$buildings$4 === void 0 ? void 0 : _data$buildings$4.buildingSquare) !== 'undefined' ? "".concat(data.buildings[0].buildingSquare) : ''
        };
        data.propertyContacts.map(item => {
          store.contactInformation.teammembers.map(teammemberItem => {
            if (teammemberItem.id === item.teamMemberId && teammemberItem.accountId !== getParent(store).account.userProfile.id) {
              if (item.contactType === BUILDING_CONTACT_TYPES.building && store.contactInformation.selectBuildingContacts.filter(contactUnit => contactUnit.id === item.teamMemberId).length === 0) {
                store.contactInformation.selectBuildingContacts.push({
                  id: teammemberItem.id,
                  firstName: teammemberItem.firstName,
                  lastName: teammemberItem.lastName,
                  userRole: teammemberItem.userRole,
                  email: teammemberItem.email,
                  emailConfirmed: teammemberItem.emailConfirmed
                });
              }
              if (item.contactType === BUILDING_CONTACT_TYPES.utility && store.contactInformation.selectUtilitiesContacts.filter(contactUnit => contactUnit.id === item.teamMemberId).length === 0) {
                store.contactInformation.selectUtilitiesContacts.push({
                  id: teammemberItem.id,
                  firstName: teammemberItem.firstName,
                  lastName: teammemberItem.lastName,
                  userRole: teammemberItem.userRole,
                  email: teammemberItem.email,
                  emailConfirmed: teammemberItem.emailConfirmed
                });
              }
            }
          });
        });
        if (areEqual(store.contactInformation.selectBuildingContacts, store.contactInformation.selectUtilitiesContacts)) {
          store.contactInformation.selectUtilitiesContacts = cast([]);
        }
        store.portfolioId = data.portfolioId;
        if (data.portfolioIds) store.portfolioIds = data.portfolioIds;
        if (data !== null && data !== void 0 && (_data$accountAccess = data.accountAccess) !== null && _data$accountAccess !== void 0 && _data$accountAccess.accountIds) store.accountAccess = data === null || data === void 0 || (_data$accountAccess2 = data.accountAccess) === null || _data$accountAccess2 === void 0 ? void 0 : _data$accountAccess2.accountIds;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    addBuildingContacts(data) {
      try {
        store.contactInformation.teammembers.map(teammemberItem => {
          if (teammemberItem.id === data) {
            var _teammemberItem$email3;
            store.contactInformation.selectBuildingContacts.push({
              id: teammemberItem.id,
              firstName: teammemberItem.firstName,
              lastName: teammemberItem.lastName,
              userRole: teammemberItem.userRole,
              email: (_teammemberItem$email3 = teammemberItem.email) !== null && _teammemberItem$email3 !== void 0 ? _teammemberItem$email3 : teammemberItem.newEmail,
              emailConfirmed: teammemberItem.emailConfirmed
            });
          }
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    addUtilitiesContacts(data) {
      try {
        store.contactInformation.teammembers.map(teammemberItem => {
          if (teammemberItem.id === data) {
            var _teammemberItem$email4;
            store.contactInformation.selectUtilitiesContacts.push({
              id: teammemberItem.id,
              firstName: teammemberItem.firstName,
              lastName: teammemberItem.lastName,
              userRole: teammemberItem.userRole,
              email: (_teammemberItem$email4 = teammemberItem.email) !== null && _teammemberItem$email4 !== void 0 ? _teammemberItem$email4 : teammemberItem.newEmail,
              emailConfirmed: teammemberItem.emailConfirmed
            });
          }
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    removeBuildingContacts(data) {
      try {
        store.contactInformation.selectBuildingContacts.map((selectUtilitiesContact, index) => {
          if (selectUtilitiesContact.id === data) {
            store.contactInformation.selectBuildingContacts.splice(index, 1);
          }
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    removeUtilitiesContacts(data) {
      try {
        store.contactInformation.selectUtilitiesContacts.map((selectUtilitiesContact, index) => {
          if (selectUtilitiesContact.id === data) {
            store.contactInformation.selectUtilitiesContacts.splice(index, 1);
          }
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    removeTeammembers() {
      try {
        store.contactInformation.teammembers = cast([]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setVacantUnitUsage(id, value) {
      try {
        store.vacantUnitUsageValue.set(id, value);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
}).views(store => ({
  get propertyInformationSnapshot() {
    return store.propertyInformation;
  },
  get vacantUnitUsage() {
    return store.vacantUnitUsageValue;
  },
  get vacantUnitUsageLimit() {
    return store.vacantUnitUsageLimitValue;
  }
}));
export const addNewProperty = types.optional(AddNewProperty, {});